import React from 'react';
import { Box, Flex } from 'rebass/styled-components';
import PropTypes from 'prop-types';
import pluralize from 'pluralize';
import { TableColumns } from './tableColumns';
import { TableSort } from './tableSort';

export const TableActions = ({
  leftActions,
  rightActions,
  topBanner,
  showTableActions,
  itemName,
  onColumnAction,
  initialSortBy,
  canSort,
  selectedColumns,
  selectedColumn,
  setSelectedColumns,
  setSelectedColumn,
  tableActions,
  handleSort,
  totalItems,
  sortedColumns,
  sx,
}) => (
  <>
    <Flex
      sx={{
        alignItems: 'center',
        justifyContent: ['space-between', 'space-between', 'flex-start'],
        mb: '18px',
        width: '100%',
        gap: ['0', '0', '16px'],
        pr: ['16px', '16px', '32px'],
        ...sx,
      }}
    >
      {leftActions}
      <Box color="text.main" fontSize="12px" lineHeight="24px" ml={showTableActions ? '16px' : '0'}>
        {`Showing all ${totalItems} ${pluralize(itemName, totalItems)}`}
      </Box>
      <Flex
        sx={{
          justifyContent: ['flex-end', 'flex-end', 'space-between'],
          alignItems: 'center',
          gap: '16px',
          flex: 1,
        }}
      >
        <Flex sx={{ alignItems: 'center', gap: [0, 0, '8px'] }}>
          <TableColumns
            selectedColumns={selectedColumns}
            setSelectedColumns={(item, action, column) => {
              setSelectedColumns(item);
              onColumnAction?.(action, { payload: column });
            }}
          />
          {canSort && (
            <TableSort
              selectedSort={{
                value: initialSortBy,
                label: initialSortBy.desc ? 'Descending' : 'Ascending',
              }}
              setSelectedSort={({ value }) => handleSort(value, selectedColumn.value)}
              columns={sortedColumns.filter((column) => !column.disableSortBy)}
              selectedColumn={selectedColumn}
              setSelectedColumn={(column) => {
                setSelectedColumn(column);
                handleSort(initialSortBy.desc ? 'desc' : 'asc', column.value);
              }}
            />
          )}
          {tableActions}
        </Flex>
        {rightActions}
      </Flex>
    </Flex>
    <Box>{topBanner}</Box>
  </>
);

TableActions.propTypes = {
  leftActions: PropTypes.node,
  rightActions: PropTypes.node,
  topBanner: PropTypes.node,
  showTableActions: PropTypes.bool,
  itemName: PropTypes.string,
  onColumnAction: PropTypes.func,
  initialSortBy: PropTypes.object,
  canSort: PropTypes.bool,
  selectedColumns: PropTypes.array,
  selectedColumn: PropTypes.object,
  setSelectedColumns: PropTypes.func,
  setSelectedColumn: PropTypes.func,
  tableActions: PropTypes.node,
  handleSort: PropTypes.func,
  totalItems: PropTypes.number,
  sx: PropTypes.object,
  sortedColumns: PropTypes.array,
};

TableActions.defaultProps = {
  showTableActions: true,
  itemName: 'item',
  selectedColumns: [],
  selectedColumn: null,
  setSelectedColumns: () => {},
  setSelectedColumn: () => {},
  canSort: false,
  tableActions: null,
  leftActions: null,
  rightActions: null,
  topBanner: null,
  onColumnAction: () => {},
  initialSortBy: null,
  handleSort: () => {},
  totalItems: 0,
  sx: {},
  sortedColumns: [],
};

export default TableActions;
